/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

/////////////////////////
// Project permissions //
/////////////////////////
// Create Permissions //
////////////////////////
export const create: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// Create Permissions > New project
export const createNewProject: RoleList = [...create];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

// Update Permissions > Edit project
export const updateEditProject: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ASSET_MANAGER,
  ...update,
];

// Update Permissions > Assign project lead
export const updateAssignProjectLead: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ASSET_MANAGER,
  ...update,
];

// Update Permissions > Assign users to project
export const updateAssignUsers: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ASSET_MANAGER,
  ...update,
];

// Update Permissions > Remove users from project
export const updateRemoveUsers: RoleList = [Roles.MANAGER, Roles.ACCOUNT_ADMIN, Roles.SYSTEM_ADMIN];

// Update Permissions > Assign cost centers to project
export const updateAssignCostCenters: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.SYSTEM_ADMIN_REGIONAL,
  ...update,
];

// Update Permissions > Remove cost centers from project
export const updateRemoveCostCenters: RoleList = [Roles.MANAGER, Roles.PURCHASER, ...update];

// Update Permissions > Extend project
export const updateExtendProject: RoleList = [Roles.MANAGER, Roles.PURCHASER, ...update];

// Update Permissions > end project
export const updateEndProject: RoleList = [Roles.MANAGER, Roles.PURCHASER, ...update];

// Update Permissions > Unarchive project
export const updateUnarchiveProject: RoleList = [...update, Roles.MANAGER];

// Update Permissions > Archive project
export const updateArchiveProject: RoleList = [...update, Roles.MANAGER];

// Update Permissions > Remove projects from project
export const updateRemoveProjects: RoleList = [Roles.MANAGER, Roles.PURCHASER, ...update];
